import { Checkbox, Form, Popover } from "antd";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

const WeldingSystemCheckbox = ({
  weldingSystem,
  handleWeldingSystemChange,
  weldTagging,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (weldTagging === "Automatic" && weldingSystem.p625) {
      handleWeldingSystemChange("p625", false);
    }
  }, [weldTagging, weldingSystem.p625, handleWeldingSystemChange]);

  const weldingSystems = [
    { value: "iwm", label: "IWM" },
    { value: "p600z", label: "P-600Z" },
    { value: "p625", label: "P-625" },
    { value: "m500", label: "M-500" },
  ];

  // Check if at least one system is selected
  const hasSelection = Object.values(weldingSystem).some((value) => value);

  // Check if IWM is selected with at least one other system
  const hasValidIWMSelection =
    !weldingSystem.iwm ||
    (weldingSystem.iwm &&
      (weldingSystem.p600z || weldingSystem.p625 || weldingSystem.m500));

  return (
    <Form.Item
      label={
        <span>
          <Popover
            content={t("projectTooltip.weldingSystem")}
            placement="topLeft"
            trigger="hover"
          >
            {t("common.weldingsystem")}
          </Popover>
        </span>
      }
      className="form-group welding-system-group"
      name="weldingSystem"
      rules={[
        {
          validator: async () => {
            if (!hasSelection) {
              return Promise.reject(
                "Please select at least one welding system"
              );
            }
            if (!hasValidIWMSelection) {
              return Promise.reject(
                "Please select either P600Z, P625 or M500 before proceeding."
              );
            }
            return Promise.resolve();
          },
        },
      ]}
      validateTrigger={["onChange", "onBlur"]}
    >
      <div className="checkbox-group">
        {weldingSystems.map((system) => (
          <Checkbox
            key={system.value}
            checked={
              weldingSystem[system.value] &&
              !(system.value === "p625" && weldTagging === "Automatic")
            }
            onChange={(e) =>
              handleWeldingSystemChange(system.value, e.target.checked)
            }
            className="checkbox-button"
            disabled={system.value === "p625" && weldTagging === "Automatic"}
          >
            {system.label}
          </Checkbox>
        ))}
      </div>
    </Form.Item>
  );
};

export default WeldingSystemCheckbox;
